module.exports = __webpack_public_path__ + "static/media/soundcloud-logo-sm.dd18aae3.png";